<template >
  <p v-if="loading"></p>
  <div v-else class="">
    <div class=" text-xl text-right mr-10 -mt-7 font-bold " :class="[colorPalette.importantText]">
      € {{data.cost.totalPriceIncl}}
    </div>
    <div class="ml-40 -mt-6 " >
      <a :href="[data.upgradeUrl]" class="underline font-bold " :class="[colorPalette.importantText]"> Upgrade?</a>
    </div>
    <!-- type, modules n options -->
    <div class="flex flex-col justify-between w-full mt-2">
      <div class="flex flex-row justify-between">
        <div class="flex flex-row">
          <div class="px-1.5 py-0.5 h-fit rounded-lg font-bold " :class="[colorPalette.importantText] + ' ' + [colorPalette.darkPillBackground]">
            {{ data.type }} (+ €{{data.cost.subtotalPriceIncl}})
          </div>
          <div class="hidden sm:block mt-1.5 ml-4">
            <nav class="flex space-x-4" aria-label="Tabs">
              <span v-for="item in data.options" :key="item.id" class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium " :class="[colorPalette.pillText] + ' ' + [colorPalette.pillBackground]"> {{item.name}} (+ {{item.price}}) </span>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div  class="w-full mt-4 ">
      <div class="w-full mt-2">
        <div class="w-full border-t border-gray-300 mb-4"></div>
        <div class="w-full  flex flex-row space-x-3 ">
          <license-bar v-for="item in data.usages"
                       :key="item.id"
                       :max="item.max"
                       :source="source"
                       :title="item.title"
                       :current="item.current"
                       :unit="item.unit"></license-bar>
        </div>
        <div class="w-full border-t border-gray-300 mt-4"></div>
      </div>
      <!-- invoice -->
      <div class="mt-2">
        <div class="w-full mt-4 ">
          <div class="flex flex-row justify-between">
            <div class="flex flex-row ">
              <div class="mr-2">Last invoice:</div>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <div class="mr-2">
                {{data.invoice.number}}
              </div>

            </div>
            <div >
              <div class="w-fit mx-auto">
                {{data.invoice.date}}
              </div>
            </div>
            <div class="flex flex-row ">
              <div class="flex flex-row">

                <div class="ml-4 mr-2">
                  € {{ data.invoice.amount }}
                </div>
                <svg v-if="data.invoice.paid" xmlns="http://www.w3.org/2000/svg" class="text-green-600 h-5 w-5 mt-0.5" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="text-red-600 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
                <a :href="[data.invoice.detailUrl]" >
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full border-t border-gray-300 mt-4"></div>
        <div class="w-full text-center pt-2">
<!--          <a :href="[data.invoice.documentUrl]" :class="[colorPalette.moreInfoUrl]">All invoices</a>-->
        </div>

      </div>
    </div>
  </div>

</template>

<script setup>
import { defineProps, onMounted, ref} from "vue";

import LicenseBar from "@/widgetContent/charts/LicenseBar";
import ApiService from "@/services/ApiService";
let apiService = new ApiService;
let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})

let data = ref(Object);
let loading = ref(true);

onMounted ( async () => {
  data.value = await apiService.get(props.source);
  loading.value = false

})
</script>
